import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { AppConfigService } from '../../../app.config';
import { DisplayModes } from '../../../models/enums';
import { Specialty } from '../../../models/lookups/speciality.model';
import { Page } from '../../../models/page.model';
import { PlanStatus } from '../../../plan/enums/plan-status.enum';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { LookupsService } from '../../../services/lookups.service';
import { UsersApiService } from '../../../services/users-api.service';
import { HCPService } from '../hcp.service';
import { SettingService } from '../../../settings/components/settings/setting.service';

@Component({
  selector: 'crm-hcp-edit-history',
  templateUrl: './edit-history.component.html',
  styleUrls: ['./edit-history.component.css']
})
export class HcpEditHistoryComponent implements OnInit {

  columns: any[] = [];
  showEnglishName: boolean = false;
  users: any[] = [];
  search: any = {};
  totalItems: number = 0;
  currentPage: number = 1;
  pageSize = 10;
  displayMode: DisplayModes = DisplayModes.Success;
  specialities: Specialty[] = new Array<Specialty>();
  rows: any[] = [];
  statuses = [
    { id: PlanStatus.pending, name: 'Pending' },
    { id: PlanStatus.approved, name: 'Approved' },
    { id: PlanStatus.rejected, name: 'Rejected' }
  ];

  @ViewChild('filterModal')
  filterModal: ModalDirective;

  constructor(private readonly alertService: AlertService, private readonly usersService: UsersApiService,
    private readonly lookupsService: LookupsService,
    private readonly hcpService: HCPService,
    private readonly appConfig: AppConfigService,
    private readonly translateService: AppTranslationService,
    private readonly settingService: SettingService) { }

  ngOnInit() {
    this.pageSize = this.appConfig.settings.pageSize;
    this.getSpecialities();
    this.getAllUsers();
    this.searchHistory();
    this.columns = [
      { field: 'hcpName', header: this.translateService.getTranslation("app.name"), width: '15%' },
      { field: 'phone', header: this.translateService.getTranslation("hco.phone"), width: '10%' },
      { field: 'email', header: this.translateService.getTranslation("pageHeader.email"), width: '10%' },
      { field: 'specialityName', header: this.translateService.getTranslation("hco.specialty"), width: '10%' },
      { field: 'requestedByName', header: 'Requested By', width: '12%' },
      { field: 'requestDate', header: 'Requested On', width: '10%' },
      { field: 'status', header: 'Status', width: '8%' },
      { field: 'reviewedByName', header: 'Reviewed By', width: '12%' },
      { field: 'reviewDate', header: 'Reviewed On', width: '10%' }
    ];
    this.getEnglishNameSetting();
  }

  getEnglishNameSetting() {
    this.settingService.getCustomFieldLabelConfig('HCPCostumFieldLabel').subscribe(config => {
      this.showEnglishName = config.show;
      if (config.show) {
        this.columns.splice(1, 0, { field: 'englishName', header: config.label, width: '15%' });
      }
    });
  }

  getAllUsers() {
    this.usersService.getAllUsersMiniReport().subscribe(response => {
      this.users = response as any[];
    }, error => {
      this.alertService.showStickyMessage("Load Data Error", "The below errors occured whilst fetch data from server:", MessageSeverity.Error, error);
    });
  }

  getSpecialities() {
    this.hcpService.GetAllSpecialities("").subscribe(response => {
      this.specialities = response as Specialty[];
    }, () => {
      this.displayMode = DisplayModes.Error;
    });
  }

  searchHistory() {
    this.alertService.startLoadingMessage("", this.translateService.getTranslation("Searching"));
    if (this.search.user)
      this.search.userId = this.search.user.id;

    this.hcpService.getHcpEditHistory(this.search.searchText, this.currentPage,
      this.search.startDate, this.search.endDate, this.search.userId, this.search.status ? this.search.status.id : undefined).subscribe(response => {
        this.alertService.stopLoadingMessage();
        const result = response as Page;
        this.rows = result.items;
        this.totalItems = result.totalItems;
      }, err => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
  }

  pageChanged(event) {
    this.currentPage = event.first / event.rows + 1;
    this.searchHistory();
  }

  statusLabel(status: number) {
    switch (status) {
      case PlanStatus.pending: return 'Pending';
      case PlanStatus.approved: return 'Approved';
      case PlanStatus.rejected: return 'Rejected';
      default: return '';
    }
  }

  openFilterModal() {
    this.filterModal.show();
  }

  hideFilterModal() {
    this.filterModal.hide();
  }

  searchFilterModal() {
    this.currentPage = 1;
    this.filterModal.hide();
    this.searchHistory();
  }
}
